import { Label } from "@/components/ui/label";

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div className="fade-up">
      <h1 data-testid="page-title" className="font-display text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Field = ({ label, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</Label>
    {children}
  </div>
);

export const Kpi = ({ label, value, hint, tone = "slate", testid }) => {
  const tones = { slate: "text-slate-900", green: "text-emerald-700", red: "text-rose-700", blue: "text-sky-700", amber: "text-amber-700" };
  return (
    <div data-testid={testid} className="lift rounded-xl border border-slate-200 bg-white p-5">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</div>
      <div className={`mt-2 font-mono text-2xl font-semibold tracking-tight ${tones[tone]}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </div>
  );
};

export const Panel = ({ title, action, children, className = "" }) => (
  <section className={`rounded-xl border border-slate-200 bg-white ${className}`}>
    {title && (
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 px-5 py-3.5">
        <h2 className="font-display text-sm font-bold text-slate-800">{title}</h2>
        {action}
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);

export const Empty = ({ text }) => (
  <div data-testid="empty-state" className="rounded-lg border border-dashed border-slate-200 py-12 text-center text-sm text-slate-500">{text}</div>
);

export const QuotaBar = ({ used = 0, quota = 0 }) => {
  const pct = quota ? Math.min(100, Math.round((used / quota) * 100)) : used ? 100 : 0;
  const color = pct >= 90 ? "bg-rose-500" : pct >= 70 ? "bg-amber-500" : "bg-emerald-500";
  return (
    <div data-testid="quota-bar">
      <div className="mb-1 flex justify-between font-mono text-xs text-slate-600">
        <span>{used} / {quota} XML</span>
        <span>{pct}%</span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-slate-100">
        <div className={`h-full ${color} transition-[width] duration-700`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
